import * as c from "react";
import { I as o } from "./AntdIcon-D8iup6xj.js";
var s = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
function r() {
  return r = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, r.apply(this, arguments);
}
const i = (t, e) => /* @__PURE__ */ c.createElement(o, r({}, t, {
  ref: e,
  icon: s
})), l = /* @__PURE__ */ c.forwardRef(i);
process.env.NODE_ENV !== "production" && (l.displayName = "CheckOutlined");
export {
  l as R
};
